import { render, staticRenderFns } from "./BrochureGridModule.vue?vue&type=template&id=7a9ccf01&"
import script from "./BrochureGridModule.ts?vue&type=script&lang=ts&"
export * from "./BrochureGridModule.ts?vue&type=script&lang=ts&"
import style0 from "./BrochureGridModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports